/**
 * Display formatters shared across the admin portal (and anywhere else that
 * needs the same look). Intl formatters are module-level so the same
 * DateTimeFormat instance is reused on every call instead of being rebuilt per
 * render.
 */

const dateFmt = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
});

const dateTimeFmt = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

export function fmtDate(iso: string | null | undefined): string {
  return iso ? dateFmt.format(new Date(iso)) : '—';
}

export function fmtDateTime(iso: string | null | undefined): string {
  return iso ? dateTimeFmt.format(new Date(iso)) : '—';
}

export function fmtNum(n: number): string {
  return n.toLocaleString('en-US');
}
